"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButtonWithModal = void 0;
const react_1 = __importDefault(require("react"));
const Modal_1 = require("@amzn/atoz-web/Modal");
const Theme_1 = require("@amzn/atoz-web/Theme");
const IconButtonWithModal = (props) => {
    const { dataTestId, icon, renderModalArgs = [], ariaLabel, renderModal } = props;
    return (react_1.default.createElement(Modal_1.WithModal, { dataTestId: dataTestId, renderModal: ({ close }) => {
            return renderModal({ close }, ...renderModalArgs);
        } }, ({ open }) => (react_1.default.createElement(IconButton, { "aria-label": ariaLabel, onClick: open }, icon))));
};
exports.IconButtonWithModal = IconButtonWithModal;
const IconButton = (0, Theme_1.styledWithTheme)('button')(({ theme }) => `
    background-color: transparent;
    border: none;
    border-radius: 2px;

    &:hover {
      cursor: pointer;
    }

    &:focus-visible {
      outline: 2px solid ${theme.selectors.color('primary70')};
    }
  `);
